<template>
    <MainContainer background="darkGrey">
        <div class="col-xs-12 col-sm-8 col-md-7 col-lg-5 center tc">

            <!-- Informative text -->
            <img class="mt5" src='@/assets/img/404.svg'/>
            <h2 class="mt3 white">Sorry, that page doesn't exist.</h2>
            <span class="mt3 white bodyCopy dib">You can search Tooliaba using the search below or
            <router-link to="/">
                <h6 class="grow yellow dib">go to homepage.</h6>
            </router-link>
            </span>

            <!-- Searchbox -->
            <SearchCore class="pa4 mt4 bg-white mb5 custom-shadow"/>

        </div>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import SearchCore from '@/components/global/SearchCore.vue';

export default {
    components: {
        MainContainer,
        SearchCore
    }
};
</script>
